const isSupportedValue = (
    value: unknown,
): value is string | number | boolean =>
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean";

export const createFormData = (payload: Record<string, unknown>): FormData => {
    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
        if (!isSupportedValue(value)) return;
        formData.append(key, String(value));
    });

    return formData;
};